import type { MissionView } from "@frontier/content/contracts";
import { NPCS } from "@frontier/content/npcs";
import { EscortMissionStatus } from "./EscortMissionStatus";
import "./progression.css";

export function MissionRequirements({
  mission,
}: {
  mission: MissionView | null;
}) {
  if (!mission) return null;
  const terms = mission.terms;
  if (terms.escort) return <EscortMissionStatus mission={mission} />;
  if (
    mission.difficulty !== "advanced" &&
    !terms.requiredArchetypes.length &&
    !terms.requiredSurveySites.length &&
    !terms.requireRescue &&
    !terms.requireElite
  )
    return null;
  const surveys = terms.requiredSurveySites.filter((id) =>
    mission.surveyedSites.includes(id),
  ).length;
  return (
    <small className="mission-requirements" aria-label="Условия заказа">
      {mission.contractId === "hunt" && (
        <span
          className={mission.progress >= mission.goal ? "fulfilled" : "missing"}
        >
          ЗАЧЁТЫ {mission.progress}/{mission.goal}
        </span>
      )}
      {terms.requiredArchetypes.map((archetype) => (
        <span
          key={archetype}
          className={
            mission.killedArchetypes.includes(archetype)
              ? "fulfilled"
              : "missing"
          }
        >
          {NPCS[archetype].name}:{" "}
          {mission.killedArchetypes.includes(archetype) ? "✓" : "0/1"}
        </span>
      ))}
      {terms.requireElite && (
        <span className={mission.eliteKills > 0 ? "fulfilled" : "missing"}>
          КОМАНДИР {Math.min(1, mission.eliteKills)}/1
        </span>
      )}
      {terms.cargoGoal > 0 && (
        <span
          className={
            mission.cargoHeld >= terms.cargoGoal ? "fulfilled" : "missing"
          }
        >
          {terms.cargoKind === "energy" ? "ЭНЕРГИЯ" : "ГРУЗ"}{" "}
          {mission.cargoHeld}/{terms.cargoGoal}
        </span>
      )}
      {terms.requiredSurveySites.length > 0 && (
        <span
          className={
            surveys === terms.requiredSurveySites.length
              ? "fulfilled"
              : "missing"
          }
        >
          МАЯКИ {surveys}/{terms.requiredSurveySites.length}
        </span>
      )}
      {terms.requireRescue && (
        <span className={mission.rescue === "saved" ? "fulfilled" : "missing"}>
          СПАСЕНИЕ:{" "}
          {mission.rescue === "saved"
            ? "ЗАЧТЕНО"
            : mission.rescue === "lost"
              ? "ТРАНСПОРТ ПОТЕРЯН"
              : mission.rescue === "active"
                ? "НУЖНО ЛИЧНОЕ УЧАСТИЕ"
                : "ОЖИДАНИЕ СИГНАЛА"}
        </span>
      )}
    </small>
  );
}
